// Your Cloud Run function URL
const CLOUD_FUNCTION_URL = 'https://receipt-processing-api-421033887213.europe-west1.run.app';

export const processReceipt = async (imageFile) => {
  try {
    console.log('Starting receipt processing...');
    console.log('Calling:', CLOUD_FUNCTION_URL);

    const base64Image = await fileToBase64(imageFile);

    const response = await fetch(CLOUD_FUNCTION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        image: base64Image
      })
    });

    const data = await response.json();

    if (!response.ok) {
      console.error('Error response:', data);
      throw new Error(data.error || 'Failed to process receipt');
    }

    console.log('Success! Entities found:', data.metadata?.entitiesCount);
    return data;

  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = error => reject(error);
  });
};